import React from "react";
import { Card } from "antd";

const ChartCard = ({ title, icon: Icon, children }) => {
    return (
        <Card
            title={
                <span style={{ fontWeight: "bold" }}>
                    {Icon && <Icon style={{ marginRight: 8 }} />}
                    {title}
                </span>
            }
            bordered={true}
            style={{
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                overflow: "hidden",
                height: "100%",
            }}
            headStyle={{
                backgroundColor: "#fafafa",
                borderBottom: "1px solid #f0f0f0",
            }}
        >
            {children}
        </Card>
    );
};

export default ChartCard;